import { SceneControllerPlugin } from '@jollywise/jollygoodgame';

export class SceneControllerPluginTT extends SceneControllerPlugin {
  constructor(...args) {
    super(...args);
    this._overlayStack = [];
  }

  showOverlayScene(sceneKey, { data, onOverlayClosed = null } = {}) {
    if (this.overlaySceneKey) {
      this.pauseScene(this.overlaySceneKey);
      this._overlayStack.push(this.overlaySceneKey);
    }
    this.overlaySceneKey = sceneKey;
    this.onOverlayClosed = onOverlayClosed;
    this.pauseScene(this.currentSceneKey);
    this.startScene(sceneKey, { data });
    if (this.paused) {
      this.pauseScene(sceneKey);
    }
  }

  removeOverlayScene() {
    if (this.overlaySceneKey) {
      this.stopScene(this.overlaySceneKey);

      if (this._overlayStack.length) {
        this.overlaySceneKey = this._overlayStack.pop();
        this.resumeScene(this.overlaySceneKey);
      } else {
        if (!this.paused) {
          this.resumeScene(this.currentSceneKey);
        }
        this.overlaySceneKey = null;
        if (this.onOverlayClosed) {
          const t = this.onOverlayClosed;
          this.onOverlayClosed = null;
          setTimeout(t, 100);
        }
      }
    }
  }
}
